// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ExecutedBurn } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

export const useExecutedBurns2Step: () => UseQueryResult<
  TemplateContract<ExecutedBurn>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOptions({
    queryKey: ['queryExecutedBurnsTwoStep', operator],
    queryFn: async (_, options) => {
      return ledgerApi.query(options, ExecutedBurn);
    },
  });
};
